import axios from 'axios'

const StudentLostItemService = {
  async report (data) {
    const formData = new FormData()

    Object.entries(data || {}).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') return
      formData.append(key, value)
    })

    return axios.post('student/lost-items/report', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  async myReports (params = {}) {
    return axios.get('student/lost-items/my-reports', { params })
  }
}

export default StudentLostItemService
